<template>
  <div>
    <v-dialog
      v-if="$checkPermission('view_sip_status_logs')"
      v-model="dialogHistory"
      width="900px"
      content-class="dialog-border-radius"
    >
      <template v-slot:activator="{ on, attrs }">
        <p class="hist-but" v-on="on" v-bind="attrs">
          История изменения SIP статуса
        </p>
      </template>
      <v-card class="border">
        <v-card-title style="display: contents">
          <v-card class="card-header" style="box-shadow: none;">
            <span class="text-h5" v-if="!isCheckSizeSmall">История изменения SIP статуса</span>
            <span class="text-h5" v-else>История SIP</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="$checkPermission('export_sip_status_logs')"
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="btn-download-sip"
                  @click="downloadLogs"
                >
                  <v-icon large>mdi-download-box-outline</v-icon>
                </v-btn>
              </template>
              <span>Скачать историю</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  right
                  class="btn__icon pa-0"
                  style="position: absolute; right: 15px; height: 50%"
                  width="18"
                  @click="dialogHistory = false"
                >
                  <v-icon color="white">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Закрыть</span>
            </v-tooltip>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headersSip"
            :items="sipHistory"
            :items-per-page="20"
            hide-default-footer
          >
            <template v-slot:item.new_sip_status="{ item }">
              <v-icon
                x-small
               :color="(type === 'barrier' && (item.new_sip_status === '2' || item.new_sip_status === '-1')) || item.new_sip_status === '2' ? 'green' : 'red'"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              {{ getSipStatus(item.new_sip_status) }}
            </template>
            <template v-slot:item.old_sip_status="{ item }">
              <v-icon
                x-small
                :color="(type === 'barrier' && (item.old_sip_status === '2' || item.old_sip_status === '-1')) || item.old_sip_status === '2' ? 'green' : 'red'"
              >
                mdi-checkbox-blank-circle
              </v-icon>
              {{ getSipStatus(item.old_sip_status) }}
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ ruDateFormat(item.created_at) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import { headersSip } from '@/components/doorphone/DetailDoorphone/consts';
import { mapActions } from 'vuex';

export default {
  mixins: [ruDateFormatMixin],
  name: 'HistorySipStatusDialog',
  props: {
    isCheckSizeSmall: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    sipHistory: {
      type: Array,
    },
  },
  data () {
    return {
      headersSip,
      dialogHistory: false,
      isUpdatedSip: false,
    };
  },
  methods: {
    ...mapActions({
      exportSipHistoryCsv: 'Doorphone/exportSipHistoryCsv',
      exportSipHistoryCsvBarrier: 'Barriers/exportSipHistoryCsvBarrier',
      exportSipHistoryCsvGate: 'Gate/exportSipHistoryCsvGate',
    }),
    downloadLogs () {
      const type = this.type;
      let exportFunction;
      switch (type) {
        case 'doorphone':
          exportFunction = this.exportSipHistoryCsv(this.$route.params.id);
          break;
        case 'barrier':
          exportFunction = this.exportSipHistoryCsvBarrier(this.$route.params.id);
          break;
        case 'gate':
          exportFunction = this.exportSipHistoryCsvGate(this.$route.params.id);
          break;
        default:
          this.$flash_warning('Неизвестный тип устройства');
          return;
      }
      exportFunction
        .then((response) => {
          const data = new Blob([response], { type: 'application/csv' });
          const a = document.createElement('a');
          a.download = `sip-status-logs-${type}.csv`;
          a.href = URL.createObjectURL(data);
          a.click();
        })
        .catch(() => {
          this.$flash_warning('Не удалось скачать историю');
        });
    },
    getSipStatus (status) {
      if (this.type === 'barrier') {
        switch (status) {
          case '-1': return ' (В сети) ';
          case '2': return ' (В сети) ';
          default: return ' (Не в сети) ';
        }
      } else if (this.type === 'gate') {
        switch (status) {
          case '2': return ' (Доступен) ';
          default: return ' (Не в сети) ';
        }
      } else {
        switch (status) {
          case '-1': return ' (Не зарегистрировано) ';
          case '0': return ' (Не зарегистрировано) ';
          case '1': return ' (Регистрация) ';
          case '2': return ' (Зарегистрировано) ';
          case '3': return ' (Не удалось зарегистрироваться) ';
          default: return ' (Не в сети) ';
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
.border {
  border-radius: 16px;
}

.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
  font-weight: 400 !important;
  font-size: 15px !important;
  margin-bottom: 0 !important;
}
.btn-download-sip {
  position: absolute;
  right: 22%;
  height: 60%;
}
@media screen and (max-width: 800px) {
  .v-application p {
    font-size: 15px;
    padding-top: 5px;
  }
  .btn-download-sip {
    right: 11%;
  }
}
@media screen and (max-width: 800px) {
  .hist-but {}
}
</style>
